import Vue from 'vue'
import Router from 'vue-router'
import {
  loadLanguageAsync
} from '@/i18n'
import Default from '@/layouts/default'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Default,
      children: [
        {
          path: '',
          name: 'index',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        }, {
          path: '/latest',
          name: 'latest',
          component: () => import( /*webpackChunkName: "latest"*/ '../pages/latest.vue')
        },
        {
          path: '/mine/:pid',
          name: 'folder',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        },
        {
          path: '/auto',
          name: 'auto',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        },
        {
          path: '/team',
          name: 'teams',
          component: () => import( /*webpackChunkName: "teams"*/ '../pages/teams.vue')
        },
        {
          path: '/team/:tid',
          name: 'team',
          component: () => import( /*webpackChunkName: "teams"*/ '../pages/teams.vue')
        },
        {
          path: '/team/:tid/:fid',
          name: 'teamFolder',
          component: () => import( /*webpackChunkName: "teams"*/ '../pages/teams.vue')
        },
        {
          path: '/trash',
          name: 'trash',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        },
        {
          path: '/trash/:fid',
          name: 'trashFolder',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        },
        {
          path: '/search/:search',
          name: 'search',
          component: () => import( /*webpackChunkName: "idx"*/ '../pages/index.vue')
        },
      {
        path: '/received',
        name: 'received',
        component: () => import( /*webpackChunkName: "received"*/ '../pages/received.vue')
      },
      {
        path: '/shared',
        name: 'shared',
        component: () => import( /*webpackChunkName: "received"*/ '../pages/received.vue')
      },
      {
        path: '/starred',
        name: 'starred',
        component: () => import( /*webpackChunkName: "starred"*/ '../pages/starred.vue')
      }]
    },
    {
      path: '/join/:jid',
      name: 'join',
      component: () => import( /*webpackChunkName: "join"*/ '../layouts/join.vue')
    },
    {
      path: '/view/:fileid',
      name: 'preview',
      component: () => import( /*webpackChunkName: "preview"*/ '../layouts/preview.vue')
    }, 
    {
      path: '/view/:fileid/:historyid',
      name: 'previewHistory',
      component: () => import( /*webpackChunkName: "preview"*/ '../layouts/preview.vue')
    },
    {
      path: '/promotion/space',
      name: 'space',
      component: () => import('../pages/promotions/space')
    },
    {
      path: '/404',
      name: '404',
      component: () => import( /*webpackChunkName: "404"*/ '../pages/404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
router.beforeEach((to, from, next) => {
  let lang = to.query.lang || from.query.lang
  let langs = ['de-DE', 'en-GB', 'en-US', 'es-ES', 'es-MX', 'fr-CA', 'fr-FR', 'id-ID', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'th-TH']
  lang = lang ? lang.replace('_', '-') : 'en-US'
  lang = lang && langs.indexOf(lang) > -1 ? lang : 'en-US'
  loadLanguageAsync(lang).then(() => {
    if (Object.keys(from.query).length && !Object.keys(to.query).length) {
      next({
        name: to.name,
        params: to.params,
        query: from.query
      })
    } else {
      next()
    }
  })
  
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js